@if (label()) {
  <div class="label truncate" i18n>Teléfono</div>
}
<div class="value">
  <a class="qaroni-link-on-surface" href="tel:{{ phone() }}">{{ phone() }}</a>
</div>
